<div class="sectionbar">
  <app-ordre-nav></app-ordre-nav>
  <div class="sectionbar__actions"></div>
</div>
<div class="topbar">
  <h1>Ordrer</h1>
  <div class="topbar__actions">
    @if (serviceordrer.length > 0) {
      <small>Viser {{ serviceordrer.length }} af {{ rowCount }} ordrer</small>
    }
    @if (filter.periodFrom) {
      <small>&nbsp;fra d. {{ filter.periodFrom | date : 'dd-MM-yyyy' }}</small>
    }
    @if (filter.periodTo) {
      <small>&nbsp;til d. {{ filter.periodTo | date : 'dd-MM-yyyy' }}</small>
    }
    <button class="btn-icon" [matTooltip]="'Download ordre listen som excel ark'">
      <mat-icon svgIcon="download" class="icon-32" (click)="download()"></mat-icon>
    </button>
    <app-ordre-filter [filter]="filter" class="filter flex"></app-ordre-filter>
    <div class="search-wrap">
      <app-search [searchString]="searchQuery" label="Find ordre"></app-search>
    </div>
  </div>
</div>
<div class="page__content orders orders--list">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="sortData($event)"
    [matSortActive]="filter.orderBy"
    [matSortDirection]="filter.orderDir"
    class="mat-elevation-z0 has-notifications table-show-overflow"
    [class.has-notifications--x2]="filter.showParked"
    >
    <ng-container matColumnDef="opfoelgning">
      <th mat-header-cell class="hidden-cell" *matHeaderCellDef></th>
      <td mat-cell class="hidden-cell" [class.hidden-cell--pinned]="button(serviceordre) > 0" *matCellDef="let serviceordre">
        <button
          type="button"
          class="btn-icon opacity-hover"
          [class.opfoelgning-bookmark]="button(serviceordre)"
          (click)="opfoelgning($event, serviceordre)"
          [disabled]="!canWrite"
          >
          <app-opfoelgning-button [opfoelgningList]="serviceordre.opfoelgningList"></app-opfoelgning-button>
        </button>
      </td>
    </ng-container>
    <ng-container matColumnDef="parked">
      <th mat-header-cell class="hidden-cell" *matHeaderCellDef></th>
      <td
        mat-cell
        *matCellDef="let serviceordre"
        class="hidden-cell"
        [class.hidden-cell--pinned]="serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Parked"
        >
        @if (serviceordre.serviceordreStateEnum == serviceordreStatusEnum.Parked) {
          <button
            type="button"
            class="btn-icon"
            (click)="opfoelgning($event, serviceordre)"
            >
            <mat-icon svgIcon="park"></mat-icon>
          </button>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="Serviceaftale.Serviceabonnement.Produkt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
      <td mat-cell *matCellDef="let serviceordre">
        <mat-icon [svgIcon]="getProductIcon(serviceordre)" [matTooltip]="getProductIcon(serviceordre) | titlecase"></mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="ServiceordreNo">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ordrenr</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.serviceordreNo }}
          @if (serviceordre.poster && serviceordre.poster.length > 0) {
            <mat-icon
              class="material-icons"
              matTooltip="Der er posteringer på denne ordre"
              svgIcon="table"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Serviceaftale.OkKundeAftalenr">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Aftalenr</th>
      <td mat-cell *matCellDef="let serviceordre">{{ serviceordre.okKundeAftalenr }}</td>
    </ng-container>
    <ng-container matColumnDef="Opgave">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Opgave</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.opgaveDisplayText }}
          @if (getNotes(serviceordre)) {
            <mat-icon
              class="material-icons"
              svgIcon="note"
              class="cursor-help"
              [matTooltip]="getNotes(serviceordre)"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="ServiceordreStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
      <td mat-cell *matCellDef="let serviceordre">
        @if (serviceordre.serviceordreStateEnum === serviceordreStatusEnum.ValidationFailed) {
          <button type="button" class="btn-icon icon-with-text orange" (click)="handleValidationFailed($event, serviceordre)">
            <mat-icon svgIcon="obs-solid"></mat-icon>
            <span>
              {{ serviceordre.serviceordreStateUserText }}
              @if (serviceordre.serviceordreValidationFailedReason == ValidationFailedReason.CreditCheckFailed) {
                <span>- Kreditstop</span>
              }
            </span>
          </button>
        }
        @if (serviceordre.serviceordreStateEnum != serviceordreStatusEnum.ValidationFailed) {
          {{ serviceordre.serviceordreStateUserText }}
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="Leveringsdato">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Leveringsdato</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.leveringsdato | date : 'dd.MM.yyyy' }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Oprettid">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Oprettet</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.createdOn | date : 'dd.MM.yyyy' }}
          <mat-icon [matTooltip]="serviceordre.createdBy" class="cursor-help" svgIcon="avatar"></mat-icon>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Ajourtid">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Ændret</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.modifiedOn | date : 'dd.MM.yyyy' }}
          @if (!serviceordre.serviceordreAfregning?.automaticApprovedForAccounting) {
            <mat-icon
              [matTooltip]="serviceordre.modifiedBy"
              class="cursor-help"
              svgIcon="avatar"
            ></mat-icon>
          }
          @if (serviceordre.serviceordreAfregning?.automaticApprovedForAccounting) {
            <mat-icon
              [matTooltip]="serviceordre.modifiedBy + ' - Automatisk godkendt'"
              class="cursor-help"
              svgIcon="avatar-system"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Partner.Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
      <td mat-cell *matCellDef="let serviceordre">
        <div class="flex-wrap flex-wrap--align-center flex-wrap--flex-start">
          {{ serviceordre.partner.name }}
          @if (serviceordre.partnerafregningBilagsnr) {
            <mat-icon
              class="material-icons"
            matTooltip="Parter er afregnet {{ serviceordre.partnerafregningBeloebExclMoms | dkCurrency }} på bilag {{
              serviceordre.partnerafregningBilagsnr
            }}"
              svgIcon="table"
            ></mat-icon>
          }
          @if (serviceordre.partner.id !== serviceordre.originalPartnerId) {
            <mat-icon
              class="material-icons"
              matTooltip="Oprindelig partner var {{ serviceordre.originalPartnerName }}"
              svgIcon="directions-left-right"
            ></mat-icon>
          }
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      (click)="onRowClick(row)"
      class="cursor-pointer"
      [class.active]="globalActiveRowID == row.id"
      [appScrollToRow]="prevRow"
      [rowId]="row.serviceordreNo"
      (rowActive)="highLight($event)"
      *matRowDef="let row; columns: displayedColumns; index as i"
    ></tr>
  </table>
  @if (page < pageCount) {
    <div class="align-center margin-top-x2">
      <button type="button" mat-raised-button color="accent" class="btn-trans mat-elevation-z0" (click)="more()">Vis flere ordrer</button>
    </div>
  }
</div>
